import type { ProgramDetailValues } from './types';

// TODO: 測試用資料，記得刪除
export const DUMMY_PROGRAM_DETAIL: ProgramDetailValues = {
  name: '兒童繪畫班',
  category: '藝術',
  plans: ['基礎班', '進階班'],
  teacher: '王小明',
  maximumEnrollment: 20,
  minimumEnrollment: 5,
  enrollment: {
    startTime: 1748736000000,
    endTime: 1751328000000,
  },
  description: '透過繪畫培養兒童的創造力與專注力',
  includedPayment: '含材料費',
  note: '請自備畫具',
  image: null,
  isPaidProgram: true,
  payments: ['creditCard', 'point'],
  pricing: {
    member: {
      price: 2000,
      point: 2000,
      limit: 15,
    },
    nonMember: {
      price: 2500,
      point: 2500,
      limit: 5,
    },
  },
  isRegular: true,
  irregular: {
    place: null,
    address: null,
  },
  program: {
    startTime: 1756684800000,
    endTime: 1767139200000,
  },
  scheduleType: ['fixedTime'],
  fixedSchedule: [
    {
      isDayChecked: true,
      startTime: 1672275600000, // 09:00
      endTime: 1672290000000, // 13:00
      place: '文化中心',
      address: '台北市中山區中山路1號',
    },
    {
      isDayChecked: false,
      startTime: null,
      endTime: null,
      place: '社區活動中心',
      address: '台北市大安區和平東路二段134號',
    },
    {
      isDayChecked: true,
      startTime: 1672293600000, // 14:00
      endTime: 1672304400000, // 17:00
      place: '藝術教室',
      address: '台北市信義區松仁路100號',
    },
    {
      isDayChecked: false,
      startTime: null,
      endTime: null,
      place: '兒童美術館',
      address: '台北市士林區至善路二段221號',
    },
    {
      isDayChecked: true,
      startTime: 1672275600000, // 09:00
      endTime: 1672290000000, // 13:00
      place: '青少年活動中心',
      address: '台北市松山區八德路四段12號',
    },
    {
      isDayChecked: false,
      startTime: null,
      endTime: null,
      place: '圖書館藝文空間',
      address: '台北市內湖區成功路四段70號',
    },
    {
      isDayChecked: true,
      startTime: 1672293600000, // 14:00
      endTime: 1672304400000, // 17:00
      place: '社區藝術中心',
      address: '台北市文山區木柵路一段100號',
    },
  ],
  nonFixedSchedule: [
    {
      date: 1756742400000, // 2025/09/02 00:00
      startTime: 1756774800000, // 2025/09/02 09:00
      endTime: 1756803600000, // 2025/09/02 17:00
      place: '台北市民生社區活動中心',
      address: '台北市松山區民生東路五段163-1號',
    },
    {
      date: 1759248000000, // 2025/10/01 00:00
      startTime: 1759280400000, // 2025/10/01 09:00
      endTime: 1759309200000, // 2025/10/01 17:00
      place: '台北市立圖書館總館',
      address: '台北市大安區建國南路二段125號',
    },
    {
      date: 1761840000000, // 2025/10/31 00:00
      startTime: 1761872400000, // 2025/10/31 09:00
      endTime: 1761901200000, // 2025/10/31 17:00
      place: '台北市青年發展處',
      address: '台北市仁愛路一段17號',
    },
    {
      date: 1764518400000, // 2025/12/01 00:00
      startTime: 1764550800000, // 2025/12/01 09:00
      endTime: 1764579600000, // 2025/12/01 17:00
      place: '台北市社會局',
      address: '台北市信義區市府路1號',
    },
  ],
  refundPolicy: '開課前7天取消全額退費，開課前3天取消退費50%，開課後不予退費',
};
